import React from 'react';
import { i18n } from 'config/locales';

const TechnologyIntro = function () {
  return (
    <div>
      {i18n.m('legal.pvq.technology.intro.bullet')}
      {i18n.m('legal.pvq.technology.intro.bullet1')}
      <ul>

        <li>{i18n.m('legal.pvq.technology.intro.bulletone')}</li>
        <li>{i18n.m('legal.pvq.technology.intro.bullettwo')}</li>
        <li>{i18n.m('legal.pvq.technology.intro.bulletthree')}</li>
        <li>{i18n.m('legal.pvq.technology.intro.bulletfour')}</li>
      </ul>
    </div>
  );
};

export default TechnologyIntro;
